import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { browserHistory } from 'react-router';
// elements
import { Card, CardHeader, CardText } from 'material-ui/Card';
import { statusColours } from '../../constants/ColourConstants';
import DetailView from '../Common/DetailView';
// icons
import EditIcon from 'material-ui/svg-icons/editor/mode-edit';
import VendorIcon from 'material-ui/svg-icons/places/business-center';

// constants
import ROLES from '../../constants/Roles';
// business logic
import buildContextMenu from '../Common/BuildContextMenu';
import VendorStore from '../../stores/VendorStore';
import VendorActions from '../../actions/VendorActionCreator';

const style = {
    icon: {
        height: '32px',
        width: '32px',
    }
};

class Vendor extends Component {

    constructor(props, context) {
        super(...arguments);

        this.state = {
            details: {
                id: '',
                name: '',
                description: '',
            },
            actions: buildContextMenu(this.getActions(this.props.routeParams.id), this.context.auth),
        };
    }

    componentDidMount() {
        this.onChange = this.onChange.bind(this);
        VendorStore.addChangeListener(this.onChange);
        VendorActions.getById(this.props.routeParams.id);
    }

    componentWillUnmount() {
        VendorStore.removeChangeListener(this.onChange);
    }

    getActions(id) {
        return [
            {
                link: `/dashboard/vendor/${id}/edit`,
                label: 'Edit',
                icon: <EditIcon />,
                condition: {
                    roles: [ROLES.ADMIN]
                }
            },
            {
                type: 'deleteDialog',
                dialogType: 'menu',
                value: this.props.routeParams.id,
                title: 'Delete vendor',
                deleteAction: this.onDelete,
                message: (
                    <span>
                        Are you sure to delete this vendor?
                    </span>
                ),
                condition: {
                    roles: [ROLES.ADMIN]
                }
            }
        ];
    }

    render() {
        const detailProps = {
            title: 'Vendor',
            backButton: true,
            actions: this.state.actions
        };
        
        return(
            <DetailView {...detailProps} >
                <div className="cent-cards">
                    <Card className="cent-card">
                        <CardHeader
                            title={this.state.details.name}
                            subtitle="details"
                            avatar={<VendorIcon style={style.icon} color={statusColours.primary} />}

                        />
                        <CardText className="cent-card-text">
                            {this.state.details.description}
                        </CardText>
                    </Card>
                </div>
            </DetailView>
      );
    }

    onChange(){
        const details = VendorStore.getById(this.props.routeParams.id);
        if (details !== undefined) {
            this.setState({details: details});
        }
    }

    onDelete(entityId) {
        if (entityId == this.props.routeParams.id) {
            VendorActions.delete(entityId);
            browserHistory.goBack();
        }
    }

}

Vendor.contextTypes = {
    auth:   PropTypes.object.isRequired
};

export default Vendor;
